module.exports = __webpack_public_path__ + "static/media/send-to-phone.b62882d3.svg";